import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

Swiper.use([Navigation]);

export default function () {
	const announcement_bar = document.querySelectorAll('.announcement-bar-slider');

    if(!announcement_bar || document.querySelectorAll('.announcement-bar-slider .swiper-slide').length <= 1) return;

    announcement_bar.forEach((carousel) => {
        const config = {
            slidesPerView: 1,
            autoplay: {
                delay: 5000,
                pauseOnMouseEnter: true,
                disableOnInteraction: false,
            },
            loop: true,
            navigation: {
                nextEl: carousel.querySelector(
                    '.announcement-bar-slider-next'
                ),
                prevEl: carousel.querySelector(
                    '.announcement-bar-slider-prev'
                ),
            },
        };

        new Swiper(carousel, config);
    });
}
